// Product-plate gallery: arrows that step through the shots filed for the
// selected colourway.
//
// The plate itself is server-rendered (ERB owns the page, per DESIGN.md §7.1),
// so this never builds markup — it only decides which of the shots is showing,
// and takes a new set from the AddToCart island when the colourway changes.

type ColourwayShots = { images: string[]; name: string }

export function mountPlate(): void {
  const root = document.getElementById('plate-shots')
  if (!root) return

  const img = document.getElementById('plate-image') as HTMLImageElement | null
  const prev = document.getElementById('plate-prev')
  const next = document.getElementById('plate-next')
  const count = document.getElementById('plate-count')
  const caption = document.getElementById('plate-colourway')
  if (!img || !prev || !next || !count) return

  const product = root.dataset.product ?? ''
  let shots: string[] = JSON.parse(root.dataset.shots ?? '[]')
  let colourway = caption?.textContent ?? ''
  let index = 0

  const show = (to: number) => {
    if (shots.length === 0) return
    // Wrap rather than dead-end. With two or three shots an arrow that goes grey
    // is more irritating than the loop is disorienting.
    index = (to + shots.length) % shots.length
    img.src = shots[index]
    img.alt =
      shots.length > 1
        ? `${product} — ${colourway} (${index + 1}/${shots.length})`
        : `${product} — ${colourway}`
    count.textContent = `${index + 1}/${shots.length}`
    root.classList.toggle('single', shots.length < 2)
    // Warm the frame the next arrow press will want, so the step is instant
    // without pulling the whole set down for someone who never opens it.
    if (shots.length > 1) new Image().src = shots[(index + 1) % shots.length]
  }

  prev.addEventListener('click', () => show(index - 1))
  next.addEventListener('click', () => show(index + 1))

  // Bubbles up from whichever arrow has focus, so the keys work without making
  // the container itself a tab stop.
  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1) }
    if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1) }
  })

  document.addEventListener('plate:colourway', (e) => {
    const detail = (e as CustomEvent<ColourwayShots>).detail
    shots = detail.images
    colourway = detail.name
    if (caption) caption.textContent = detail.name
    show(0)
  })

  show(0)
}
